import React from "react";
import { formatDate } from '../../utils/formatDate';
import { oddToString } from '../../utils/oddToString';
import { getLabel } from "../../../data/labels";

export default function SystemBetsDetailTicketFixtures(props) {
     const ticketData = props.ticketData;
     const clearBoth = {clear: "both"};

     return (
             <>
                  <div className="separator"></div>
                  <div className="textcenter td-100 ticketType uppercase">{getLabel('printer.system_bet_details_ticket.header.reminder')}</div>
                  <div className="separator"></div>
                  {ticketData?.fixtures && Object.values(ticketData?.fixtures).map(f=> {
                     const reactKey = 'ticket-selection-' + f.pal + "-" + f.avv;
                     return (
                         <>
                             <div key={reactKey} className="event_sistemi">
                                  <div className="event_row">
                                     <div className="palavv_sistemi left bold">{f.pal}&nbsp;{f.avv}</div>
                                     <div className="event_descr truncate_event_descr bold">{f.eventDesc}</div>
                                     <div style={clearBoth}></div>
                                  </div>
                                 <div className="tournament_row_sistemi">
                                     <div className="sport_descr_sistemi truncate_sport_descr_sistemi left">{f.sportDesc}</div>   
                                     <div className="tournament_descr_sistemi truncate_tournament_descr_sistemi right">{f.tournamentDesc}</div>  
                                     <div className="date_event_sistemi">{formatDate(f.timestamp).formatted}</div> 
                                     <div style={clearBoth}></div>
                                 </div>  
                                 <div className="bet">
                                     <div className="td-10 left bet_descr uppercase">{f.pr}&#41;</div>
                                     <div className="td-50 left bet_descr uppercase">{f.betDesc}</div>
                                     <div className="td-25 left draw_descr uppercase">{f.outcome}</div>
                                     <div className="td-15 left odd textright bold">{oddToString(f.price)}</div>
                                     <div style={clearBoth}></div>
                                 </div>
                             </div>
                         </>
                         
                     )
                 })}
            
             </>
         )
}